import { Box, Button, Checkbox, FormControlLabel, Typography } from "@mui/material";
import * as React from "react";
import { setNotifyFormula } from "../../../../../services/local-session-storage";
import { AppModal } from "../../../../../components/ui";

type Props = {
    open: boolean
    onClose: () => void
    onConfirm: () => void
}

export const DoseNotifyDialog: React.FC<Props> = ({ open, onClose, onConfirm }) => {

    const handleOnChange = (checkableValue: boolean) => {
        setNotifyFormula(checkableValue)
    }

    const handleConfirm = () => {
        onConfirm()
        onClose()
    }

    return (
        <AppModal
            open={open}
            onClose={onClose}
            kicker="Aviso"
            title="Sua fórmula será salva no histórico"
            maxWidth={480}
            footer={
                <Button variant="contained" onClick={handleConfirm} sx={{ height: 46, px: 3 }}>
                    Ok
                </Button>
            }
        >
            <Box>
                <Typography sx={{ fontSize: "14.5px", color: "text.secondary", lineHeight: 1.6 }}>
                    Ao concluir ou gerar PDF, sua fórmula será salva no histórico. Na aba “Histórico de Consultas” você
                    pode conferir seu histórico de fórmulas montadas, editar consultas, agrupar fórmulas e gerar novos
                    PDFs.
                </Typography>
                <FormControlLabel
                    sx={{ mt: 1.5 }}
                    control={<Checkbox color="primary" onChange={(_, checked) => handleOnChange(checked)} />}
                    label={<Typography sx={{ fontSize: "13.5px", color: "text.primary" }}>Não exibir essa mensagem novamente</Typography>}
                />
            </Box>
        </AppModal>
    )
}
